<!-- //NOSONAR UL-Element in äusserem Component --><li class="dataset-item clear-margin-bottom">
  <div class="dataset-content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-xs-12 item-content-name">
          <h2>
            <a class="item-content-name"
               routerLink="/adura/{{ meldung.type }}/{{ this.meldung.code }}" [innerHTML]="meldung.titel"></a>
            <span class="doc-item-format">
                  <h3 class="sr-only">{{ "format.label" | translate }}:</h3>
                  <label>({{ meldung.code }})</label>
            </span>
            <span class="cursor-pointer" (click)="openMeldung(meldung.code)" *ngIf="isEditable()">
                  <i class="fa fa-edit adura-preview-tooltip" title="{{ 'adura.steckbrief.edit' | translate }}"></i>
            </span>
            <i class="fa fa-eye adura-preview-tooltip"
               (mouseover)="toggleKurzInfoHidden()"
               (mouseleave)="toggleKurzInfoHidden()">
            </i>
          </h2>
        </div>
        <div class="col-xs-12 clear-padding-left {{ kurzInfoHidden ? 'hidden' : '' }}">
          <p class="kurz-info" [innerHTML]="meldung.kurzinfo"></p>
        </div>
        <div class="col-xs-12 col-md-3 clear-padding-left">
          <p [attr.aria-label]="('global.created' | translate) + ': ' + (meldung.erfDate | date: 'dd.MM.yyyy')">
            {{ 'global.created' | translate }}: {{ meldung.erfDate | date: 'dd.MM.yyyy' }}</p>
        </div>
        <ul class="col-xs-12 col-md-9 dataset-resources list-inline tags clear-padding-left">
          <ng-container *ngFor="let bereich of meldung.bereiche">
            <li class="nav-item filter-tag" [ngClass]="(isBereichPrimaer(bereich))?'active':''">
              <a role="button" class="filter-tag-label">{{ bereich }}</a>
            </li>
          </ng-container>
        </ul>
        <div class="col-xs-12 col-md-12 clear-padding-left">
          <a href="{{ basisQuelleLink }}" target="_blank">{{ meldung.basisQuelle }}</a>
          <p *ngIf="!isProd()">Faktor: {{ meldung.relevanzFaktor }}</p>
        </div>
      </div>
    </div>
  </div>
</li>
